import {Typography} from "@mui/material";

export const Text = ({children}) => {
    return <Typography sx={{margin: "0px 0 10px 0"}}>
        {children}
    </Typography>
}